<template>
    <span class="close">⒳</span>
</template>

<script>
// import '@/assets/svg/close.svg?sprite';

export default {
    name: 'close-icon',
}

</script>
<style lang="scss" scoped>
    .close {
        position: fixed;
        z-index: 99;
        top: var(--padding);
        right: var(--padding);
        padding: 0 1rem;
        cursor: pointer;
        font-size: var(--padding-x2);
    }
    @media only screen and (max-width: 767px) {
        .close {
            position: relative;
            right: unset;
            left: var(--padding);
        }
    }
</style>